<template>
  <global-layout @dynamicRouterShow="dynamicRouterShow">
    <a-back-top />
    <!-- update-begin- author:sunjianlei --- date:20191009 --- for: 提升右键菜单的层级 -->
    <contextmenu :itemList="menuItemList" :visible.sync="menuVisible" style="z-index: 9999" @select="onMenuSelect" />
    <!-- update-end- author:sunjianlei --- date:20191009 --- for: 提升右键菜单的层级 -->
    <a-tabs
      @contextmenu.native="(e) => onContextmenu(e)"
      v-if="multipage"
      :active-key="activePage"
      class="tab-layout-tabs tab-layout-submenus"
      style="height: 41px"
      :hide-add="true"
      type="editable-card"
      @change="changePage"
      @tabClick="tabCallBack"
      @edit="editPage"
    >
      <a-tab-pane
        :id="page.path"
        :key="page.path"
        v-for="page in XEUtils.filter(pageList, (r) => r.path != '/refresh')"
      >
        <span slot="tab" :pagekey="page.path">{{ $getTextByLocale(page.meta.title) }}</span>
      </a-tab-pane>
    </a-tabs>
    <div class="router-view-wrapper">
      <keep-alive v-if="multipage">
        <router-view v-if="reloadFlag" ref="RouteView" />
      </keep-alive>
      <template v-else>
        <router-view v-if="reloadFlag" ref="RouteView" />
      </template>
    </div>
  </global-layout>
</template>

<script>
import GlobalLayout from '@/components/page/GlobalLayout'
import Contextmenu from '@/components/menu/Contextmenu'
import { mixin, mixinDevice } from '@/utils/mixin.js'
import { triggerWindowResizeEvent } from '@/utils/util'
import mainVue from '@/main.js'

const indexKey = '/dashboard/analysis'

export default {
  name: 'TabLayout',
  components: {
    GlobalLayout,
    Contextmenu,
  },
  mixins: [mixin, mixinDevice],
  data() {
    return {
      pageList: [],
      linkList: [],
      activePage: '',
      menuVisible: false,
      debounce: false,
      menuItemList: [
        { key: '4', icon: 'reload', text: this.$t('disp.refresh') },
        { key: '1', icon: 'arrow-left', text: this.$t('disp.closeLeft') },
        { key: '2', icon: 'arrow-right', text: this.$t('disp.closeRight') },
        { key: '3', icon: 'close', text: this.$t('disp.closeOthers') },
      ],
      reloadFlag: true,
      blockFlag: false,
    }
  },
  provide() {
    // return {
    //   closeCurrent: this.closeCurrent
    // }
    return {
      renamePage: this.renamePage,
    }
  },
  computed: {
    multipage() {
      //判断如果是手机模式，自动切换为单页面模式
      if (this.isMobile()) {
        return false
      } else {
        return this.$store.state.app.multipage
      }
    },
  },
  created() {
    console.info('TabLayout created')

    if (this.$route.path != indexKey && !window.pageList && !window.linkList) {
      this.addIndexToFirst()
    }

    let storeKey = 'route:title:' + this.$route.path
    let routeTitle = this.$ls.get(storeKey)
    if (routeTitle) {
      this.$route.meta.title = routeTitle
    }

    if (window.pageList) {
      this.pageList = XEUtils.clone(window.pageList, true)
    } else {
      this.pageList.push(this.$route)
    }

    if (window.linkList) {
      this.linkList = XEUtils.clone(window.linkList, true)
    } else {
      this.linkList.push(this.$route.path)
    }

    this.activePage = this.$route.path

    window.pageList = undefined
    window.linkList = undefined
  },
  watch: {
    $route: function (newRoute) {
      var componentName = newRoute.name.split('-')[newRoute.name.split('-').length - 1]
      // 强制刷新列表里面不包含当前组件，则检查该组件是否应该被强制刷新
      if (!this.$store.state.app.noKeepAlive.includes(componentName)) {
        if (newRoute.meta && !newRoute.meta.keepAlive) {
          this.$store.state.app.noKeepAlive.push(componentName)
        }
      }
      // 强制刷新列表里面包含当前组件，则检查该组件是否已被刷新过
      else {
        if (newRoute.meta && newRoute.meta.keepAlive) {
          let index = this.$store.state.app.noKeepAlive.indexOf(componentName)
          this.$store.state.app.noKeepAlive.splice(index, 1)
        }
      }

      this.activePage = newRoute.path
      if (!this.multipage) {
        this.linkList = [newRoute.path]
        this.pageList = [Object.assign({}, newRoute)]
      } else if (indexKey == newRoute.path) {
        //首页时 判断是否缓存 没有缓存 刷新之
        if (newRoute.meta.keepAlive === false) {
          this.routeReload(indexKey)
        }
      } else if (this.linkList.indexOf(newRoute.path) < 0) {
        this.pageList.push(Object.assign({}, newRoute))
        this.linkList.push(newRoute.path)
      } else if (this.linkList.indexOf(newRoute.path) >= 0) {
        let oldIndex = this.linkList.indexOf(newRoute.path)
        let oldPositionRoute = this.pageList[oldIndex]
        this.pageList.splice(oldIndex, 1, Object.assign({}, newRoute, { meta: oldPositionRoute.meta }))
      }
    },
    activePage: function (key) {
      let index = this.linkList.lastIndexOf(key)
      let waitRouter = this.pageList[index]
      this.$router.push(Object.assign({}, waitRouter))
      this.changeTitle($getTextByLocale(waitRouter.meta.title))
    },
    multipage: function (newVal) {
      if (this.reloadFlag) {
        if (!newVal) {
          this.linkList = [this.$route.path]
          this.pageList = [this.$route]
        }
      }
    },
    device() {
      if (this.multipage && this.linkList.indexOf(indexKey) === -1) {
        this.addIndexToFirst()
      }
    },
  },
  methods: {
    // 将首页添加到第一位
    addIndexToFirst() {
      this.pageList.splice(0, 0, {
        name: 'dashboard-analysis',
        path: indexKey,
        fullPath: indexKey,
        meta: {
          icon: 'dashboard',
          title: mainVue.$i18n.t('disp.menu.Home'),
        },
      })
      this.linkList.splice(0, 0, indexKey)
    },
    changeTitle(title) {
      let projectTitle = '楷码集团信息系统'
      // 首页特殊处理
      if (this.$route.path === indexKey) {
        document.title = projectTitle
      } else {
        document.title = title + ' · ' + projectTitle
      }
    },
    changePage(key) {
      this.activePage = key
    },
    tabCallBack() {
      this.$nextTick(() => {
        triggerWindowResizeEvent()
      })
    },
    editPage(key, action) {
      this[action](key)
    },
    remove(key) {
      if (key == indexKey) {
        this.$message.warning(this.$t('disp.portalCannotClose'))
        return
      }
      if (this.pageList.length === 1) {
        this.$message.warning('这是最后一页，不能再关闭了')
        return
      }

      this.changeNeedReloadList(key, true)

      this.pageList = this.pageList.filter((item) => item.path !== key)
      let index = this.linkList.indexOf(key)
      this.linkList = this.linkList.filter((item) => item !== key)
      index = index >= this.linkList.length ? this.linkList.length - 1 : index
      this.activePage = this.linkList[index]
    },
    onContextmenu(e) {
      const pagekey = this.getPageKey(e.target)
      if (pagekey !== null) {
        e.preventDefault()
        this.menuVisible = true
      }
    },
    getPageKey(target, depth) {
      depth = depth || 0
      if (depth > 2) {
        return null
      }
      let pageKey = target.getAttribute('pagekey')
      pageKey =
        pageKey || (target.previousElementSibling ? target.previousElementSibling.getAttribute('pagekey') : null)
      return pageKey || (target.firstElementChild ? this.getPageKey(target.firstElementChild, ++depth) : null)
    },
    onMenuSelect(key, target) {
      let pageKey = this.getPageKey(target)
      switch (key) {
        case '1':
          this.closeLeft(pageKey)
          break
        case '2':
          this.closeRight(pageKey)
          break
        case '3':
          this.closeOthers(pageKey)
          break
        case '4':
          this.routeReload(pageKey)
          break
        default:
          break
      }
    },
    renamePage(newName) {
      let index = this.linkList.indexOf(this.$route.path)
      this.pageList[index].meta.title = newName
    },
    closeCurrent() {
      this.remove(this.activePage)
    },
    closeOthers(pageKey) {
      let index = this.linkList.indexOf(pageKey)

      let tempList = [...this.pageList]
      var that = this
      // 閉じられるページはリロードするように
      tempList.slice(1).forEach((item) => {
        if (item.path != that.pageList[index].path) {
          that.changeNeedReloadList(item.path, true)
        }
      })

      if (pageKey == indexKey || pageKey.indexOf('?ticke=') >= 0) {
        this.linkList = this.linkList.slice(index, index + 1)
        this.pageList = this.pageList.slice(index, index + 1)
        this.activePage = this.linkList[0]
      } else {
        let indexContent = this.pageList.slice(0, 1)[0]
        this.linkList = this.linkList.slice(index, index + 1)
        this.pageList = this.pageList.slice(index, index + 1)
        this.linkList.unshift(indexContent.path)
        this.pageList.unshift(indexContent)
        this.activePage = this.linkList[1]
      }
    },
    closeLeft(pageKey) {
      if (pageKey == indexKey) {
        return
      }

      let tempList = [...this.pageList]

      var that = this
      // 閉じられるページはリロードするように
      tempList.slice(1, index).forEach((item) => {
        that.changeNeedReloadList(item.path, true)
      })

      let indexContent = tempList.slice(0, 1)[0]
      let index = this.linkList.indexOf(pageKey)
      this.linkList = this.linkList.slice(index)
      this.pageList = this.pageList.slice(index)
      this.linkList.unshift(indexContent.path)
      this.pageList.unshift(indexContent)
      if (this.linkList.indexOf(this.activePage) < 0) {
        this.activePage = this.linkList[0]
      }
    },
    closeRight(pageKey) {
      let tempList = [...this.pageList]

      var that = this
      // 閉じられるページはリロードするように
      tempList.slice(index + 1).forEach((item) => {
        that.changeNeedReloadList(item.path, true)
      })

      let index = this.linkList.indexOf(pageKey)
      this.linkList = this.linkList.slice(0, index + 1)
      this.pageList = this.pageList.slice(0, index + 1)
      if (this.linkList.indexOf(this.activePage < 0)) {
        this.activePage = this.linkList[this.linkList.length - 1]
      }
    },
    dynamicRouterShow(key, title) {
      let keyIndex = this.linkList.indexOf(key)
      if (keyIndex >= 0) {
        let currRouter = this.pageList[keyIndex]
        let meta = Object.assign({}, currRouter.meta, { title: title })
        this.pageList.splice(keyIndex, 1, Object.assign({}, currRouter, { meta: meta }))
        if (key === this.activePage) {
          this.changeTitle(title)
        }
      }
    },
    routeReload(pageKey) {
      // hong@20221003 生产环境的代码是正确的,但是开发中就使用的话会因为hotfix产生白板
      // 开发环境
      if (window._CONFIG['isDebug']) {
        this.reloadFlag = false
        let ToggleMultipage = 'ToggleMultipage'
        this.$store.dispatch(ToggleMultipage, false)
        this.$nextTick(() => {
          this.$store.dispatch(ToggleMultipage, true)
          this.reloadFlag = true
        })
      }
      // 生产环境
      else {
        this.changeNeedReloadList(pageKey)
      }
    },
    changeNeedReloadList(pageKey, closeFlg) {
      if (window._CONFIG['isDebug'] && closeFlg) {
        this.$refs.RouteView.forchRefresh()
      }

      let index = this.linkList.indexOf(pageKey)
      var componentName = this.pageList[index].name.split('-')[this.pageList[index].name.split('-').length - 1]
      if (!this.$store.state.app.noKeepAlive.includes(componentName)) {
        this.$store.state.app.noKeepAlive.push(componentName)
      }

      if (pageKey == this.activePage && !closeFlg) {
        if (this.blockFlag) {
          return
        }

        this.blockFlag = true
        setTimeout(() => {
          this.blockFlag = false
        }, 1000)

        var currRouter = this.$route
        window.pageList = this.pageList
        window.linkList = this.linkList

        this.$router.push({
          path: '/refresh',
          params: { _: new Date() },
        })
        setTimeout(() => {
          this.$router.push(currRouter)
          XEUtils.remove(this.pageList, (r) => r.path == '/refresh')
          XEUtils.remove(this.linkList, (r) => r == '/refresh')
        }, 1)

        //if (pageKey == indexKey) {
        //  this.$router.push({
        //    path: indexKey,
        //    query: Object.assign({}, this.$route.query, { _: +new Date() }),
        //  })
        //} else {
        //  this.$router.push({
        //    path: indexKey,
        //  })
        //  setTimeout(() => {
        //    this.$router.push(currRouter)
        //  }, 1)
        //}
      }
    },
  },
}
</script>

<style lang="less">
/*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* 修改 ant-tabs 样式 */
.tab-layout-tabs.ant-tabs {
  border-bottom: 1px solid #e1e1e1;
  //border-left: 1px solid #ccc;
  background-color: white;
  padding: 0 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .ant-tabs-bar {
    margin: 0px 0 0;
    border: none;
  }

  // &.ant-tabs-card .ant-tabs-tab {
  //   padding: 0 24px !important;
  //   background-color: white !important;
  //   margin-right: 10px !important;

  //   .ant-tabs-close-x {
  //     width: 12px !important;
  //     height: 12px !important;
  //     opacity: 0 !important;
  //     cursor: pointer !important;
  //     font-size: 12px !important;
  //     margin: 0 !important;
  //     position: absolute;
  //     top: 36%;
  //     right: -10px;
  //   }

  //   &:hover .ant-tabs-close-x {
  //     opacity: 1 !important;
  //   }
  // }
}

.router-view-wrapper {
  padding: 11px 12px;
  // height: calc(100vh - 111px);
  height: calc(100vh - 92px);
  overflow-y: auto;
  overflow-x: auto;
  //background-image: url('/Sprinkle.svg')
}

.mobile .router-view-wrapper {
  height: calc(100vh - 51px);
}

.router-view-wrapper::-webkit-scrollbar {
  width: 0px;
}
// .tab-layout-tabs > .ant-tabs-bar {
//   .ant-tabs-tab {
//     border: none !important;
//     border-bottom: 1px solid transparent !important;
//   }
// }
// .ant-tabs {
//   &.ant-tabs-card .ant-tabs-tab {
//     padding: 0 24px !important;
//     background-color: white !important;
//     margin-right: 10px !important;

//     .ant-tabs-close-x {
//       width: 12px !important;
//       height: 12px !important;
//       opacity: 0 !important;
//       cursor: pointer !important;
//       font-size: 12px !important;
//       margin: 0 !important;
//       position: absolute;
//       top: 36%;
//       right: 6px;
//     }

//     &:hover .ant-tabs-close-x {
//       opacity: 1 !important;
//     }
//   }
// }
</style>
